import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { GlobalFilterComponent } from '../../global-components/global-filter/global-filter.component';
import { MatIconModule } from '@angular/material/icon';
import { ConfigService } from '../../../lib/shared-services/config.service';

@Component({
  selector: 'app-side-navbar',
  standalone: true,
  imports: [
    CommonModule,
    GlobalFilterComponent,
    MatIconModule
  ],
  templateUrl: './side-navbar.component.html',
  styleUrl: './side-navbar.component.scss',
})
export class SideNavbarComponent implements OnInit {
  filters: any;

  constructor(private service: ConfigService) {}
  // constructor(
  //   private router: Router,
  //   private keycloakService: KeycloakService,
  //   private cdr: ChangeDetectorRef,
  //   private service: ConfigService
  // ) {
  //   this.menu = this.service.getMenuItems();
  //   this.getQuarter();
  //   Object.keys(this.menu).forEach(mainMenu => {
  //     this.mapRoutesRecursive(this.menu[mainMenu], mainMenu);
  //   });
  ngOnInit(): void {
    this.loadFilters();
  }

  loadFilters() {
    this.filters = { layout: 'columns',year_filter:false
 };
  }
   openHelpPdf() {
    let key: any = localStorage.getItem("key") || 'home'

    // if (this.currentRoute == '/landing-page') {
    //   key = 'home';
    // }
    console.log('PDF Key:', key);
    this.service.getPdf('home').subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);

      // Open in new tab
      window.open(url, '_blank');

      // Download as well
      // const a = document.createElement('a');
      // a.href = url;
      // a.download = `${this.key}.pdf`;
      // a.click();
      // window.URL.revokeObjectURL(url);
    });
  }
}